import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WhatsAppConfigResponseDto } from '../../../models/organization/dto/organization.dto';
import { useApiClient } from '../../../apiClient';
import { GET_WHATSAPP_CONFIG_QUERY_KEY } from './useGetWhatsAppConfig';

export type UpdateWhatsAppConfigInput = {
    whatsappEnabled?: boolean;
    whatsappPhoneNumberId?: string;
    whatsappBusinessAccountId?: string;
    whatsappAccessToken?: string;
    whatsappReplacementNotifyPhone?: string;
    whapiApiToken?: string;
    whapiGroupId?: string;
};

export const useUpdateWhatsAppConfig = (organizationId: string, onSuccess: () => void) => {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['updateWhatsAppConfig', organizationId],
        mutationFn: (body: UpdateWhatsAppConfigInput) =>
            apiClient.fetchApi<WhatsAppConfigResponseDto, UpdateWhatsAppConfigInput>({
                method: 'POST',
                endpoint: `organizations/${organizationId}/whatsapp-config`,
                body,
            }),
        onSuccess: (data) => {
            queryClient.setQueryData(GET_WHATSAPP_CONFIG_QUERY_KEY(organizationId), data);
            onSuccess();
        },
    });
};
